import Vue from 'vue';
export default {
  setSavedColumns(state, presets) {
    state.reportColumns.savedColumns = presets;
  },
  
  updatePreset(state, { presetId, presetData }) {
    Vue.set(state.reportColumns.savedColumns, presetId, presetData);
  },
  
  deletePreset(state, { presetId }) {
    Vue.delete( state.reportColumns.savedColumns,presetId)
  },

  setGroupsColumns(state, groups) {
    state.reportColumns.savedGroups = groups;
  },

  setDimensions(state: any, columns: any) {
    state.reportColumns.dimensions = columns;
  },

  setMetrics(state: any, columns: any) {
    state.reportColumns.metrics = columns;
  },
};
